// extracted by mini-css-extract-plugin
export default {"about":"Info_about__dQ4MF"};